// @flow
import { PRODUCT_WELLNESS } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_WELLNESS } from 'Utils/request/requestDictionary';
import { productWellnessQuery } from 'Client/cms/toolkit/product-utils/productFeatures.queries';

export const productWellnessResolver = {
  name: PRODUCT_WELLNESS,
  resolve(
    appContext: AppContext,
    props: ProductWellnessLineCMSProps,
    pageContext: PageContext,
    location: RouterLocation<ProductUrlParams>,
  ): Promise<ProductWellnessLineProps> {
    const { urlParams } = location;
    const { resortId: productId } = props;
    const query = productWellnessQuery(productId, { urlParams });
    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_WELLNESS,
      strictErrors: false,
    });
  },
};
